/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../js/global";
import * as helper from "../../js/helper";
import full_loading from "../components/full-loading.vue";
import vueSlider from "vue-slider-component";
const __vue_script__ = {
  components: {
	full_loading: full_loading,
	vueSlider: vueSlider,
  },
  name: "add_property_widget",
  props: {
	property: {
	  type: Object,
	},
	is_child: {
	  type: Boolean,
	  default: false,
	},
	is_edit: {
	  type: Boolean,
	  default: false,
	},
	previewImage: null,
  },
  data() {
	return {
	  is_ready:false,
	  global,
	  helper,
	  frappe,
	  section_features: global.property_constants.section_features,
	  rega_features: global.property_constants.rega_features,
	  section_details: global.property_constants.section_details,
	  property: null,
	  map: null,
	  map_marker: null,
	  mapsLayerGroup: null,
	  marker_popup: null,
	  target_latlng: null,
	  initial_lat_lng: null,
	  markerLayerGroup: null,
	  marks_0_10: (val) => ({
		label: val === 10 ? "10+" : `${val}`,
		// labelStyle: {
		//     color: val==property.no_bed?'#014116':'#cccccc',
		//     fontWeight: val==property.no_bed?'BOLD':'NORMAL',
		// }
	  }),
	};
  },
  mounted() {
	// this.property.price_sqr_meter = this.property.price_sqr_meter.toFixed(0);
	global.emitter.on("update-property-form", (args) => {
	  this.$forceUpdate();
	});
	// this.property = this.property_obj;
	this.setup_things([this.property.lat,this.property.lng]);
	// this.property.total_price = this.property.total_price.toFixed(0);
  },
  methods: {
	setup_things: async function (initial_lat_lng = [24.69999996, 46.73333003]) {
	  var initial_lat = initial_lat_lng[0]; 
	  var initial_lng = initial_lat_lng[1];
	  if (!this.is_child) {
		let corner1 = L.latLng(31.896210012370656, 33.96066018865814);
		let corner2 = L.latLng(17.613607036429755, 55.8301100044458);
		var google_street_layer = L.tileLayer(
		  "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
		  {
			maxZoom: 18,
			minZoom: 6,
			subdomains: ["mt0", "mt1", "mt2", "mt3"],
			attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
		  }
		);
		var google_satellite_layer = L.tileLayer(
		  "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
		  {
			maxZoom: 18,
			minZoom: 6,
			subdomains: ["mt0", "mt1", "mt2", "mt3"],
			attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
		  }
		);
		var open_street = L.tileLayer(
		  "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
		  {
			maxZoom: 18,
			minZoom: 6,
			attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
		  }
		);
		this.mapsLayerGroup = new L.LayerGroup();
		this.markerLayerGroup = new L.LayerGroup();
		this.map = L.map("map", {
		  center: [initial_lat, initial_lng],
		  zoom: 17,
		  maxZoom: 18,
		  minZoom: 12,
		  dragging: false,
		  maxBounds: L.latLngBounds(corner1, corner2),
		  layers: [
			this.mapsLayerGroup,
			this.markerLayerGroup,
		  ],
		}); //.setView([26.354351281510784, 43.95774780060444], 11);
		this.map.scrollWheelZoom.disable();
		this.mapsLayerGroup.addLayer(open_street);

		this.map_marker = L.marker([initial_lat, initial_lng]);
		this.marker_popup = L.popup();
		this.markerLayerGroup.addLayer(this.map_marker);
		this.map_marker.bindPopup(this.marker_popup);
		var baseLayers = frappe.lang_dir=='ltr'?{
		  "Map 1": open_street,
		  "Map 2": google_street_layer,
		  "Satellite": google_satellite_layer,
		}:{
		  "الخريطة 1": open_street,
		  "الخريطة 2": google_street_layer,
		  "القمر الصناعي": google_satellite_layer,
		};
		var layerControl = L.control.layers(baseLayers).addTo(this.map);
		
		//.........
		var customControl =  L.Control.extend({
		  options: {
			position: 'topleft'
		  },
		});
		this.map.addControl(new customControl());
		//.........

		if (this.is_edit) {
		  latlng = L.latLng(initial_lat, initial_lng)
		  this.map_marker.setLatLng(latlng);
		  this.marker_popup.setLatLng(this.map_marker.getLatLng());
		  this.map.panTo(latlng);
		}
	  }
	  this.is_ready = true;
	  if(!this.is_edit){
		navigator.geolocation.getCurrentPosition(this.getCurrentPositionSuccess,this.getCurrentPositionError);
	  }
	},
	check_enabled: function (field) {
	  // return true;
	  if (this.property.property_type == "") return false;
	  working_fields = this.enabled_fields;
	  return working_fields.includes(field);
	},
	check_section_enabled: function (array) {
	  return this.enabled_fields.some((feature) => array.includes(feature));
	},
	remove_image(image) {
	  var image_index = this.property.images.indexOf(image);
	  if (image_index >= 0) this.property.images.splice(image_index, 1);
	  if (this.property.images.length <= this.property.main_image_index)
		this.property.main_image_index = this.property.images.length - 1;
	  if (this.property.main_image_index < 0)
		this.property.main_image_index = 0;
	  else this.validate();
	},
	pickFile() {
	  let input = null;
	  let files = null;
	  if (!this.is_child) {
		input = this.$refs.file_input_parent;
		files = input.files;
	  } else {
		input = this.$refs.file_input_child;
		files = input.files;
	  }
	  if (files && files[0]) {
		for (let index = 0; index < files.length; index++) {
		  const single_file = files[index];
		  let reader = new FileReader();
		  reader.onload = (event) => {
			var image = new Image();
			image.onload = ()=>{
			  var canvas=document.createElement("canvas");
			  var context=canvas.getContext("2d");
			  const size = 1024; // set your width
			  var scaleFactor = size / image.width;
			  canvas.width = image.width;
			  canvas.height = image.height;
			  if(image.width > image.height && image.width > size){
				scaleFactor = size / image.width;
				canvas.width = size;
				canvas.height = image.height * scaleFactor;
			  }else if(image.width < image.height && image.height > size){
				scaleFactor = size / image.height;
				canvas.width = image.width * scaleFactor;
				canvas.height = size;
			  }
			  context.drawImage(image, 0, 0, canvas.width, canvas.height);
			  this.property.images.push(
				new global.image_file({
				  data: canvas.toDataURL("image/jpeg"),
				  file: single_file.name,
				})
			  );
			}
			image.src=event.target.result;
			this.validate();
		  };
		  reader.readAsDataURL(single_file);
		}
		this.$forceUpdate();
	  }
	},
	check_error(field) {
	  return this.property.errors.includes(field) ? "error" : "";
	},
	validate() {
	  if (this.property.errors.length > 0) this.property.validate();
	},
	calculate_total_price() {
	  this.property.price_sqr_meter = Number(Number((this.property.price_sqr_meter)).toFixed(0));

	  if(this.property.price_sqr_meter < this.property.rega_data["propertyPrice"]){
		console.log("in")
		this.property.price_sqr_meter = this.property.rega_data["propertyPrice"];
	  }

	  this.property.total_price = (Number(this.property.size) * this.property.price_sqr_meter).toFixed(0);
	},
	set_for_type(feature) {
	  if (feature == "is_family") {
		if (!this.property.is_family) {
		  this.property.for_type = "Single";
		} else if (this.property.for_type == "Single") {
		  this.property.for_type = "Both";
		}
	  }
	  if (feature == "is_inside_villa" && this.property.is_inside_villa) {
		this.property.is_inside_building = 0
	  }else if (feature == "is_inside_building" && this.property.is_inside_building) {
		this.property.is_inside_villa = 0
	  }
	},
	add_view_side(side){
	  normal_sides = ["N","S","E","W"]
	  diagonal_sides = ["NW","NE","SW","SE"]
	  if(this.property.view_sides.includes(side)){
		if(this.property.view_sides[0] == side)
		  this.property.view_sides.splice(this.property.view_sides.indexOf(side), 1);
		else
		  this.property.view_sides.sort(function(x,y){ return x == side ? -1 : y == side ? 1 : 0; });
		return;
	  }
	  if(normal_sides.includes(side)){
		if(this.property.view_sides.some(value => diagonal_sides.includes(value))){
		  this.property.view_sides = [];
		}
	  }else if(diagonal_sides.includes(side)){
		if(this.property.view_sides.some(value => normal_sides.includes(value))){
		  this.property.view_sides = [];
		}
	  }
	  this.property.view_sides.push(side);
	},
	active_view_side(side){
	  return this.property.view_sides.includes(side)?"active":""
	},
	main_view_side(side){
	  return this.property.view_sides[0] == side
	},
	get_view_sides(){
	  normal_sides = ["N","S","E","W"]
	  diagonal_sides = ["NW","NE","SW","SE"]
	  all_sides = ["N","S","E","W","NW","NE","SW","SE"]
	  var sides = "";
	  for (let i = 0; i < all_sides.length; i++){
		if(this.property.view_sides.includes(all_sides[i])){
		  if(this.property.view_sides[0] == all_sides[i])
			sides += all_sides[i].toLowerCase() + "m ";
		  else
			sides += all_sides[i].toLowerCase() + " ";
		}
	  }
	  if(this.property.view_sides.some(value => diagonal_sides.includes(value))){
		sides += "rotate ";
	  }
	  return sides;
	}
  },
  computed: {
	save_btn_text() {
	  if (this.property.publish) return "Save This Property & Publish Now";
	  return "Save Property";
	},
	enabled_fields() {
	  var tmp_fields =
		global.property_constants.property_types[this.property.property_type];
	  var fields = JSON.parse(JSON.stringify(Array.from(tmp_fields)));
	  global.property_constants.remove_field[this.property.ad_type].forEach(
		(field) => {
		  const index = fields.indexOf(field);
		  if (index > -1) {
			// only splice array when item is found
			fields.splice(index, 1); // 2nd parameter means remove one item only
		  }
		}
	  );
	  global.property_constants.rega_features.forEach((field) => {
		const index = fields.indexOf(field);
		if (index > -1) {
		  fields.splice(index, 1);
		}
	  });
	  return fields;
	},
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.property
    ? _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "add-listing" }, [
          _c("form", { staticClass: "basic-informations" }, [
            _c("div", { staticClass: "row" }, [
              _c("h3", {}, [
                _vm._v(_vm._s(_vm.helper.t("Additional Information")))
              ]),
              _vm._v(" "),
              _vm.check_enabled("floor_num")
                ? _c("div", { staticClass: "col-lg-4 col-sm-4" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v(_vm._s(_vm.helper.t("Floor No")))]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.property.floor_num,
                              expression: "property.floor_num"
                            }
                          ],
                          staticClass: "form-select form-control border-radius",
                          class: _vm.check_error("floor_num"),
                          attrs: { "aria-label": "Default select example" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.property,
                                  "floor_num",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.validate
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.helper.t("Select")))
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v(_vm._s(_vm.helper.t("Ground Floor")))
                          ]),
                          _vm._v(" "),
                          _vm._l(100, function(val) {
                            return _c("option", { domProps: { value: val } }, [
                              _vm._v(_vm._s(_vm.helper.t("Floor {0}", [val])))
                            ])
                          })
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.check_enabled("for_type")
                ? _c("div", { staticClass: "col-lg-4 col-md-4" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.helper.t("Property for")))
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group me-2",
                          attrs: { role: "group" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.for_type == "Both"
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.for_type = "Both"
                                  _vm.property.is_family = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("Both")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.for_type == "Family"
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.for_type = "Family"
                                  _vm.property.is_family = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("Family")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.for_type == "Single"
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.for_type = "Single"
                                  _vm.property.is_family = false
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("Singles")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.check_section_enabled(_vm.section_details)
              ? _c("div", { staticClass: "row" }, [
                  _vm.check_enabled("no_bath")
                    ? _c(
                        "div",
                        {
                          staticClass: "col-lg-4 col-sm-6 input",
                          class: _vm.check_error("no_bath")
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group mb-5" },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.helper.t("Bathrooms")))
                              ]),
                              _vm._v(" "),
                              _c("vueSlider", {
                                attrs: {
                                  process: false,
                                  adsorb: true,
                                  dragOnClick: true,
                                  contained: true,
                                  tooltip: "always",
                                  "tooltip-formatter": function(val) {
                                    return val === 10 ? val + "+" : "" + val
                                  },
                                  direction: _vm.frappe.lang_dir,
                                  "tooltip-placement": "bottom",
                                  min: 0,
                                  max: 10,
                                  marks: _vm.marks_0_10
                                },
                                on: {
                                  "drag-end": function(value) {
                                    return _vm.validate()
                                  }
                                },
                                model: {
                                  value: _vm.property.no_bath,
                                  callback: function($$v) {
                                    _vm.$set(_vm.property, "no_bath", $$v)
                                  },
                                  expression: "property.no_bath"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.check_enabled("no_living")
                    ? _c(
                        "div",
                        {
                          staticClass: "col-lg-4 col-sm-6 input",
                          class: _vm.check_error("no_living")
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group mb-5" },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.helper.t("Living Rooms")))
                              ]),
                              _vm._v(" "),
                              _c("vueSlider", {
                                attrs: {
                                  process: false,
                                  adsorb: true,
                                  dragOnClick: true,
                                  contained: true,
                                  tooltip: "always",
                                  "tooltip-formatter": function(val) {
                                    return val === 10 ? val + "+" : "" + val
                                  },
                                  direction: _vm.frappe.lang_dir,
                                  "tooltip-placement": "bottom",
                                  min: 0,
                                  max: 10,
                                  marks: function(val) {
                                    return {
                                      label: val === 10 ? "10+" : "" + val,
                                      labelStyle: {
                                        color:
                                          val == _vm.property.no_living
                                            ? "#014116"
                                            : "#cccccc",
                                        fontWeight:
                                          val == _vm.property.no_living
                                            ? "BOLD"
                                            : "NORMAL"
                                      }
                                    }
                                  }
                                },
                                on: {
                                  "drag-end": function(value) {
                                    return _vm.validate()
                                  }
                                },
                                model: {
                                  value: _vm.property.no_living,
                                  callback: function($$v) {
                                    _vm.$set(_vm.property, "no_living", $$v)
                                  },
                                  expression: "property.no_living"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.check_enabled("no_apartment")
                    ? _c(
                        "div",
                        {
                          staticClass: "col-lg-4 col-sm-6 input",
                          class: _vm.check_error("no_apartment")
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group mb-5" },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.helper.t("Total Apartments")))
                              ]),
                              _vm._v(" "),
                              _c("vueSlider", {
                                attrs: {
                                  process: false,
                                  adsorb: true,
                                  dragOnClick: true,
                                  contained: true,
                                  tooltip: "always",
                                  "tooltip-formatter": function(val) {
                                    return val === 100 ? val + "+" : "" + val
                                  },
                                  direction: _vm.frappe.lang_dir,
                                  "tooltip-placement": "bottom",
                                  min: 0,
                                  max: 100,
                                  marks: function(val) {
                                    return {
                                      label:
                                        val === 0
                                          ? "0"
                                          : val === 100
                                          ? "100+"
                                          : (val % 10 &&
                                              val !=
                                                _vm.property.no_apartment) ||
                                            val ==
                                              _vm.property.no_apartment + 1 ||
                                            val == _vm.property.no_apartment - 1
                                          ? ""
                                          : "" + val,
                                      labelStyle: {
                                        color:
                                          val == _vm.property.no_apartment
                                            ? "#014116"
                                            : "#cccccc",
                                        fontWeight:
                                          val == _vm.property.no_apartment
                                            ? "BOLD"
                                            : "NORMAL"
                                      }
                                    }
                                  }
                                },
                                on: {
                                  "drag-end": function(value) {
                                    return _vm.validate()
                                  }
                                },
                                model: {
                                  value: _vm.property.no_apartment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.property, "no_apartment", $$v)
                                  },
                                  expression: "property.no_apartment"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.check_enabled("no_shop")
                    ? _c(
                        "div",
                        {
                          staticClass: "col-lg-4 col-sm-6 input",
                          class: _vm.check_error("no_shop")
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group mb-5" },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.helper.t("Total Shops/Offices"))
                                )
                              ]),
                              _vm._v(" "),
                              _c("vueSlider", {
                                attrs: {
                                  process: false,
                                  adsorb: true,
                                  dragOnClick: true,
                                  contained: true,
                                  tooltip: "always",
                                  "tooltip-formatter": function(val) {
                                    return val === 100 ? val + "+" : "" + val
                                  },
                                  direction: _vm.frappe.lang_dir,
                                  "tooltip-placement": "bottom",
                                  min: 0,
                                  max: 100,
                                  marks: function(val) {
                                    return {
                                      label:
                                        val === 0
                                          ? "0"
                                          : val === 100
                                          ? "100+"
                                          : (val % 10 &&
                                              val != _vm.property.no_shop) ||
                                            val == _vm.property.no_shop + 1 ||
                                            val == _vm.property.no_shop - 1
                                          ? ""
                                          : "" + val,
                                      labelStyle: {
                                        color:
                                          val == _vm.property.no_shop
                                            ? "#014116"
                                            : "#cccccc",
                                        fontWeight:
                                          val == _vm.property.no_shop
                                            ? "BOLD"
                                            : "NORMAL"
                                      }
                                    }
                                  }
                                },
                                on: {
                                  "drag-end": function(value) {
                                    return _vm.validate()
                                  }
                                },
                                model: {
                                  value: _vm.property.no_shop,
                                  callback: function($$v) {
                                    _vm.$set(_vm.property, "no_shop", $$v)
                                  },
                                  expression: "property.no_shop"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.check_section_enabled(_vm.section_features)
              ? _c("div", { staticClass: "row mt-4" }, [
                  _c("div", { staticClass: "features-content" }, [
                    _c("h3", [
                      _vm._v(
                        "\n\t\t\t  " +
                          _vm._s(_vm.helper.t("Features")) +
                          "\n\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.section_features, function(feature) {
                        return _vm.check_enabled(feature) &&
                          !_vm.rega_features.includes(feature)
                          ? _c("div", { staticClass: "col-lg-3 col-md-4" }, [
                              _c("ul", [
                                _c(
                                  "li",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.property[feature] = !_vm.property[
                                          feature
                                        ]
                                        _vm.set_for_type(feature)
                                      }
                                    }
                                  },
                                  [
                                    _vm.property[feature]
                                      ? _c("i", {
                                          staticClass: "ri-checkbox-circle-fill"
                                        })
                                      : _c("i", {
                                          staticClass:
                                            "ri-checkbox-blank-circle-line"
                                        }),
                                    _vm._v(
                                      "\n\t\t\t\t\t" +
                                        _vm._s(_vm.helper.t(feature)) +
                                        "\n\t\t\t\t  "
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      }),
                      0
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.check_enabled("price_sqr_meter")
                ? _c("div", { staticClass: "col-lg-4 col-sm-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm.property.ad_type == "Rent"
                        ? _c("label", [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.property.property_type != "Land"
                                    ? _vm.helper.t("Yearly Rent")
                                    : _vm.helper.t(
                                        "Yearly rent per Square Meter"
                                      )
                                ) +
                                "\n\t\t\t  "
                            )
                          ])
                        : _c("label", [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.property.property_type != "Land"
                                    ? _vm.helper.t("Total Price")
                                    : _vm.helper.t("Price per Square Meter")
                                ) +
                                "\n\t\t\t  "
                            )
                          ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.property.price_sqr_meter,
                            expression: "property.price_sqr_meter"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        class: _vm.check_error("price_sqr_meter"),
                        attrs: {
                          type: "number",
                          min: _vm.property.rega_data["propertyPrice"]
                        },
                        domProps: { value: _vm.property.price_sqr_meter },
                        on: {
                          change: function($event) {
                            _vm.calculate_total_price()
                            _vm.validate()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.property,
                              "price_sqr_meter",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t("Cannot go below {0}", [
                              _vm.property.rega_data["propertyPrice"]
                            ])
                          )
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.property.property_type == "Land"
                ? _c("div", { staticClass: "col-lg-4 col-sm-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm.property.ad_type == "Rent"
                        ? _c("label", [
                            _vm._v(_vm._s(_vm.helper.t("Yearly Rent")))
                          ])
                        : _c("label", [
                            _vm._v(_vm._s(_vm.helper.t("Total Price")))
                          ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.property.total_price,
                            expression: "property.total_price"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        class: _vm.check_error("total_price"),
                        attrs: { type: "number", disabled: "" },
                        domProps: { value: _vm.property.total_price },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.property,
                              "total_price",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.check_enabled("description")
                ? _c("div", { staticClass: "col-lg-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.helper.t("Description")))
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.property.description,
                            expression: "property.description"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        class: _vm.check_error("description"),
                        attrs: { name: "massage", cols: "30", rows: "6" },
                        domProps: { value: _vm.property.description },
                        on: {
                          change: _vm.validate,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.property,
                              "description",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(" " + _vm._s(_vm.helper.t("Property Images")) + " ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row images-container",
                      class: _vm.check_error("main_image_index")
                    },
                    [
                      _vm._l(_vm.property.images, function(image, image_index) {
                        return _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-6 col-md-3 image-input-container"
                          },
                          [
                            _c("div", {
                              staticClass: "imagePreviewWrapper",
                              style: {
                                "background-image":
                                  "url(" +
                                  (image.link ? image.link : image.data) +
                                  ")"
                              },
                              on: {
                                click: function($event) {
                                  _vm.property.main_image_index = image_index
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "fa-solid fa-trash fa-2x delete text-danger",
                              on: {
                                click: function($event) {
                                  return _vm.remove_image(image)
                                }
                              }
                            }),
                            _vm._v(" "),
                            image_index == _vm.property.main_image_index
                              ? _c("i", {
                                  staticClass:
                                    "fa-solid fa-square-check fa-2x main text-primary"
                                })
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-3 image-input-container" },
                        [
                          _c("label", {
                            staticClass: "imageEmptyWrapper",
                            attrs: {
                              for: _vm.is_child ? "file_child" : "file_parent"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            ref: _vm.is_child
                              ? "file_input_child"
                              : "file_input_parent",
                            staticClass: "input-file",
                            attrs: {
                              id: _vm.is_child ? "file_child" : "file_parent",
                              type: "file",
                              accept: "image/png, image/gif, image/jpeg",
                              multiple: ""
                            },
                            on: { input: _vm.pickFile }
                          })
                        ]
                      )
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(
                      " " + _vm._s(_vm.helper.t("Video Link (Youtube)")) + " "
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.property.video,
                        expression: "property.video"
                      }
                    ],
                    staticClass: "form-control border-radius",
                    class: _vm.check_error("video"),
                    attrs: { type: "text" },
                    domProps: { value: _vm.property.video },
                    on: {
                      change: _vm.validate,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.property, "video", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm.check_enabled("location")
                ? _c("div", { staticClass: "col-lg-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-info",
                        attrs: { role: "alert" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa-solid fa-triangle-exclamation fa-xl"
                        }),
                        _vm._v(" "),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.helper.t(
                                "Please match the location on the map with the location according to the deed"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm.property.rega_data.locationDescriptionOnMOJDeed &&
                        _vm.property.rega_data.locationDescriptionOnMOJDeed !=
                          ""
                          ? [
                              _vm._v(
                                ": " +
                                  _vm._s(
                                    _vm.property.rega_data
                                      .locationDescriptionOnMOJDeed
                                  )
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group p-2 input position-relative",
                        class: _vm.check_error("location")
                      },
                      [
                        _c("div", { attrs: { id: "map" } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "legend top-0 start-0" }, [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.helper.t("Location Info.")))
                          ]),
                          _vm._v(" "),
                          _c("table", { staticClass: "table table-striped" }, [
                            _c("tbody", [
                              _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.helper.t("Region")))
                                ]),
                                _c("td", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.property.rega_data.location.region
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.helper.t("City")))
                                ]),
                                _c("td", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(_vm.property.rega_data.location.city)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.helper.t("District")))
                                ]),
                                _c("td", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.property.rega_data.location.district
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.helper.t("Street")))
                                ]),
                                _c("td", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.property.rega_data.location.street
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.helper.t("Postal Code")))
                                ]),
                                _c("td", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.property.rega_data.location.postalCode
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.helper.t("Building Num")))
                                ]),
                                _c("td", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.property.rega_data.location
                                        .buildingNumber
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.helper.t("Additional Num")))
                                ]),
                                _c("td", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.property.rega_data.location
                                        .additionalNumber
                                    )
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.check_enabled("allow_call")
                ? _c("div", { staticClass: "col-lg-6 col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t("Allow Users to see mobile number?")
                          )
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group me-2",
                          attrs: { role: "group" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.allow_call == false
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.allow_call = false
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("No")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.allow_call == true
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.allow_call = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("Yes")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.check_enabled("allow_whatsapp")
                ? _c("div", { staticClass: "col-lg-6 col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t("Allow Users to Contact on Whatsapp?")
                          )
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group me-2",
                          attrs: { role: "group" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.allow_whatsapp == false
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.allow_whatsapp = false
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("No")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.allow_whatsapp == true
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.allow_whatsapp = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("Yes")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.check_enabled("publish")
                ? _c("div", { staticClass: "col-lg-6 col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t("Publish on Maalek After Saving?")
                          )
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group me-2",
                          attrs: { role: "group" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.publish == false
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.publish = false
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("No")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              class:
                                _vm.property.publish == true
                                  ? "btn-primary"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.property.publish = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t  " +
                                  _vm._s(_vm.helper.t("Yes")) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-74e7c780_0", { source: "\n.image-input-container {\r\n  display: block;\r\n  position: relative;\n}\n.image-input-container .delete {\r\n  position: absolute;\r\n  top: 5%;\r\n  right: 10%;\r\n  text-shadow: 1px 1px 2px #000;\n}\n.image-input-container .main {\r\n  position: absolute;\r\n  top: 5%;\r\n  left: 10%;\r\n  text-shadow: 1px 1px 2px #000;\n}\n.image-input-container .input-file {\r\n  height: 0.1px;\r\n  width: 0.1px;\r\n  display: none;\n}\n.imagePreviewWrapper {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  display: block;\r\n  cursor: pointer;\r\n  margin: 0 auto 30px;\r\n  background-color: aliceblue;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\n}\n.imageEmptyWrapper {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  display: block;\r\n  cursor: pointer;\r\n  margin: 0 auto 30px;\r\n  background-color: aliceblue;\r\n  background-image: url(\"/assets/maalek/images/circle-plus-solid.svg\");\r\n  background-repeat: no-repeat;\r\n  background-size: 20%;\r\n  background-position: center;\n}\n.images-container {\r\n  padding: 5px;\n}\n.images-container.error {\r\n  border: SOLID 1px red;\r\n  background-color: rgba(255, 0, 0, 0.1215686275) !important;\n}\n#map {\r\n  height: 480px;\n}\n.view_sides{\r\n  direction:ltr\n}\n.view_sides .btn{\r\n  width:150px;\n}\n.view-sides-preview .preview{\r\n  height: 135px;\r\n  width: 135px;\r\n  margin: auto;\r\n  border: SOLID 10px LIGHTGRAY;\n}\n.view-sides-preview .rotate{\r\n  transform: rotateY(0deg) rotate(45deg);\n}\n.view-sides-preview .n, .view-sides-preview .ne{\r\n  border-top-color: #014116;\n}\n.view-sides-preview .s,.view-sides-preview .sw{\r\n  border-bottom-color: #014116;\n}\n.view-sides-preview .e,.view-sides-preview .se{\r\n  border-right-color: #014116;\n}\n.view-sides-preview .w, .view-sides-preview .nw{\r\n  border-left-color: #014116;\n}\n.view-sides-preview .nm, .view-sides-preview .nem{\r\n  border-top-color: orange;\n}\n.view-sides-preview .sm,.view-sides-preview .swm{\r\n  border-bottom-color: orange;\n}\n.view-sides-preview .em,.view-sides-preview .sem{\r\n  border-right-color: orange;\n}\n.view-sides-preview .wm, .view-sides-preview .nwm{\r\n  border-left-color: orange;\n}\n.leaflet-container{\r\n  font-family: \"changa\", 'Source Sans Pro', sans-serif !important;\r\n  font-size: small !important;\n}\n.legend {\r\n  margin: 100px 20px;\r\n  padding: 6px 4px;\r\n  font-size: 14px;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  line-height: 24px;\r\n  color: #555;\r\n  z-index: 500;\r\n  position: absolute;\n}\n.legend tr {\r\n  cursor: pointer;\n}\n.legend:hover {\r\n  background: white;\n}\n.legend h4 {\r\n  text-align: center;\r\n  font-size: 16px;\r\n  margin: 2px 12px 8px;\r\n  color: #777;\n}\n.legend img {\r\n  width: 20px;\r\n  height: 24px;\n}\n.legend i {\r\n  width: 18px;\r\n  height: 18px;\r\n  float: left;\r\n  margin: 0 8px 0 0;\r\n  opacity: 0.7;\n}\n.legend i.icon {\r\n  background-size: 18px;\r\n  background-color: rgba(255, 255, 255, 1);\n}\r\n\r\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/components/property-form.vue"],"names":[],"mappings":";AAi0BA;EACA,cAAA;EACA,kBAAA;AACA;AACA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,6BAAA;AACA;AACA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;AACA;AACA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AACA;AACA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;AACA;AACA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,oEAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;AACA;AACA;EACA,YAAA;AACA;AACA;EACA,qBAAA;EACA,0DAAA;AACA;AACA;EACA,aAAA;AACA;AAEA;EACA;AACA;AAEA;EACA,WAAA;AACA;AAEA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;AACA;AAEA;EACA,sCAAA;AACA;AAEA;EACA,yBAAA;AACA;AAEA;EACA,4BAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;EACA,0BAAA;AACA;AAEA;EACA,wBAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;EACA,0BAAA;AACA;AAEA;EACA,yBAAA;AACA;AAEA;EACA,+DAAA;EACA,2BAAA;AACA;AAEA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACA;AACA;EACA,eAAA;AACA;AACA;EACA,iBAAA;AACA;AACA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AACA;AAEA;EACA,qBAAA;EACA,wCAAA;AACA","file":"property-form.vue","sourcesContent":["<template>\r\n  <div v-if=\"property\" class=\"container\">\r\n\t<div class=\"add-listing\">\r\n\t  <form class=\"basic-informations\">\r\n\t\t<div class=\"row\">\r\n\t\t  <h3 class=\"\">{{ helper.t(\"Additional Information\") }}</h3>\r\n\t\t  <div v-if=\"check_enabled('floor_num')\" class=\"col-lg-4 col-sm-4\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label>{{ helper.t(\"Floor No\") }}</label>\r\n\t\t\t  <select\r\n\t\t\t\tv-model=\"property.floor_num\"\r\n\t\t\t\t:class=\"check_error('floor_num')\"\r\n\t\t\t\t@change=\"validate\"\r\n\t\t\t\tclass=\"form-select form-control border-radius\"\r\n\t\t\t\taria-label=\"Default select example\"\r\n\t\t\t  >\r\n\t\t\t\t<option value=\"\">{{ helper.t(\"Select\") }}</option>\r\n\t\t\t\t<option value=\"0\">{{ helper.t(\"Ground Floor\") }}</option>\r\n\t\t\t\t<option v-for=\"val in 100\" :value=\"val\">{{ helper.t(\"Floor {0}\",[val]) }}</option>\r\n\t\t\t  </select>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div v-if=\"check_enabled('for_type')\" class=\"col-lg-4 col-md-4\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label>{{ helper.t(\"Property for\") }}</label\r\n\t\t\t  ><br />\r\n\t\t\t  <div class=\"btn-group me-2\" role=\"group\">\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"\r\n\t\t\t\t\tproperty.for_type = 'Both';\r\n\t\t\t\t\tproperty.is_family = true;\r\n\t\t\t\t  \"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.for_type == 'Both'\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"Both\") }}\r\n\t\t\t\t</button>\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"\r\n\t\t\t\t\tproperty.for_type = 'Family';\r\n\t\t\t\t\tproperty.is_family = true;\r\n\t\t\t\t  \"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.for_type == 'Family'\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"Family\") }}\r\n\t\t\t\t</button>\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"\r\n\t\t\t\t\tproperty.for_type = 'Single';\r\n\t\t\t\t\tproperty.is_family = false;\r\n\t\t\t\t  \"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.for_type == 'Single'\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"Singles\") }}\r\n\t\t\t\t</button>\r\n\t\t\t  </div>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t</div>\r\n\t\t<div v-if=\"check_section_enabled(section_details)\" class=\"row\">\r\n\t\t  <div\r\n\t\t\tv-if=\"check_enabled('no_bath')\"\r\n\t\t\tclass=\"col-lg-4 col-sm-6 input\"\r\n\t\t\t:class=\"check_error('no_bath')\"\r\n\t\t  >\r\n\t\t\t<div class=\"form-group mb-5\">\r\n\t\t\t  <label>{{ helper.t(\"Bathrooms\") }}</label>\r\n\t\t\t  <vueSlider\r\n\t\t\t\tv-model=\"property.no_bath\"\r\n\t\t\t\t:process=\"false\"\r\n\t\t\t\t:adsorb=\"true\"\r\n\t\t\t\t:dragOnClick=\"true\"\r\n\t\t\t\t:contained=\"true\"\r\n\t\t\t\t:tooltip=\"'always'\"\r\n\t\t\t\t:tooltip-formatter=\"\r\n\t\t\t\t  (val) => (val === 10 ? `${val}+` : `${val}`)\r\n\t\t\t\t\"\r\n\t\t\t\t:direction= \"frappe.lang_dir\"\r\n\t\t\t\t:tooltip-placement=\"'bottom'\"\r\n\t\t\t\t:min=\"0\"\r\n\t\t\t\t:max=\"10\"\r\n\t\t\t\t:marks=\"marks_0_10\"\r\n\t\t\t\t@drag-end=\"(value) => validate()\"\r\n\t\t\t  ></vueSlider>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div\r\n\t\t\tv-if=\"check_enabled('no_living')\"\r\n\t\t\tclass=\"col-lg-4 col-sm-6 input\"\r\n\t\t\t:class=\"check_error('no_living')\"\r\n\t\t  >\r\n\t\t\t<div class=\"form-group mb-5\">\r\n\t\t\t  <label>{{ helper.t(\"Living Rooms\") }}</label>\r\n\t\t\t  <vueSlider\r\n\t\t\t\tv-model=\"property.no_living\"\r\n\t\t\t\t:process=\"false\"\r\n\t\t\t\t:adsorb=\"true\"\r\n\t\t\t\t:dragOnClick=\"true\"\r\n\t\t\t\t:contained=\"true\"\r\n\t\t\t\t:tooltip=\"'always'\"\r\n\t\t\t\t:tooltip-formatter=\"\r\n\t\t\t\t  (val) => (val === 10 ? `${val}+` : `${val}`)\r\n\t\t\t\t\"\r\n\t\t\t\t:direction= \"frappe.lang_dir\"\r\n\t\t\t\t:tooltip-placement=\"'bottom'\"\r\n\t\t\t\t:min=\"0\"\r\n\t\t\t\t:max=\"10\"\r\n\t\t\t\t:marks=\"\r\n\t\t\t\t  (val) => ({\r\n\t\t\t\t\tlabel: val === 10 ? '10+' : `${val}`,\r\n\t\t\t\t\tlabelStyle: {\r\n\t\t\t\t\t  color: val == property.no_living ? '#014116' : '#cccccc',\r\n\t\t\t\t\t  fontWeight: val == property.no_living ? 'BOLD' : 'NORMAL',\r\n\t\t\t\t\t},\r\n\t\t\t\t  })\r\n\t\t\t\t\"\r\n\t\t\t\t@drag-end=\"(value) => validate()\"\r\n\t\t\t  ></vueSlider>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div\r\n\t\t\tv-if=\"check_enabled('no_apartment')\"\r\n\t\t\tclass=\"col-lg-4 col-sm-6 input\"\r\n\t\t\t:class=\"check_error('no_apartment')\"\r\n\t\t  >\r\n\t\t\t<div class=\"form-group mb-5\">\r\n\t\t\t  <label>{{ helper.t(\"Total Apartments\") }}</label>\r\n\t\t\t  <vueSlider\r\n\t\t\t\tv-model=\"property.no_apartment\"\r\n\t\t\t\t:process=\"false\"\r\n\t\t\t\t:adsorb=\"true\"\r\n\t\t\t\t:dragOnClick=\"true\"\r\n\t\t\t\t:contained=\"true\"\r\n\t\t\t\t:tooltip=\"'always'\"\r\n\t\t\t\t:tooltip-formatter=\"\r\n\t\t\t\t  (val) => (val === 100 ? `${val}+` : `${val}`)\r\n\t\t\t\t\"\r\n\t\t\t\t:direction= \"frappe.lang_dir\"\r\n\t\t\t\t:tooltip-placement=\"'bottom'\"\r\n\t\t\t\t:min=\"0\"\r\n\t\t\t\t:max=\"100\"\r\n\t\t\t\t:marks=\"\r\n\t\t\t\t  (val) => ({\r\n\t\t\t\t\tlabel:\r\n\t\t\t\t\t  val === 0\r\n\t\t\t\t\t\t? '0'\r\n\t\t\t\t\t\t: val === 100\r\n\t\t\t\t\t\t? '100+'\r\n\t\t\t\t\t\t: (val % 10 && val != property.no_apartment) ||\r\n\t\t\t\t\t\t  val == property.no_apartment + 1 ||\r\n\t\t\t\t\t\t  val == property.no_apartment - 1\r\n\t\t\t\t\t\t? ''\r\n\t\t\t\t\t\t: `${val}`,\r\n\t\t\t\t\tlabelStyle: {\r\n\t\t\t\t\t  color:\r\n\t\t\t\t\t\tval == property.no_apartment ? '#014116' : '#cccccc',\r\n\t\t\t\t\t  fontWeight:\r\n\t\t\t\t\t\tval == property.no_apartment ? 'BOLD' : 'NORMAL',\r\n\t\t\t\t\t},\r\n\t\t\t\t  })\r\n\t\t\t\t\"\r\n\t\t\t\t@drag-end=\"(value) => validate()\"\r\n\t\t\t  ></vueSlider>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div\r\n\t\t\tv-if=\"check_enabled('no_shop')\"\r\n\t\t\tclass=\"col-lg-4 col-sm-6 input\"\r\n\t\t\t:class=\"check_error('no_shop')\"\r\n\t\t  >\r\n\t\t\t<div class=\"form-group mb-5\">\r\n\t\t\t  <label>{{ helper.t(\"Total Shops/Offices\") }}</label>\r\n\t\t\t  <vueSlider\r\n\t\t\t\tv-model=\"property.no_shop\"\r\n\t\t\t\t:process=\"false\"\r\n\t\t\t\t:adsorb=\"true\"\r\n\t\t\t\t:dragOnClick=\"true\"\r\n\t\t\t\t:contained=\"true\"\r\n\t\t\t\t:tooltip=\"'always'\"\r\n\t\t\t\t:tooltip-formatter=\"\r\n\t\t\t\t  (val) => (val === 100 ? `${val}+` : `${val}`)\r\n\t\t\t\t\"\r\n\t\t\t\t:direction= \"frappe.lang_dir\"\r\n\t\t\t\t:tooltip-placement=\"'bottom'\"\r\n\t\t\t\t:min=\"0\"\r\n\t\t\t\t:max=\"100\"\r\n\t\t\t\t:marks=\"\r\n\t\t\t\t  (val) => ({\r\n\t\t\t\t\tlabel:\r\n\t\t\t\t\t  val === 0\r\n\t\t\t\t\t\t? '0'\r\n\t\t\t\t\t\t: val === 100\r\n\t\t\t\t\t\t? '100+'\r\n\t\t\t\t\t\t: (val % 10 && val != property.no_shop) ||\r\n\t\t\t\t\t\t  val == property.no_shop + 1 ||\r\n\t\t\t\t\t\t  val == property.no_shop - 1\r\n\t\t\t\t\t\t? ''\r\n\t\t\t\t\t\t: `${val}`,\r\n\t\t\t\t\tlabelStyle: {\r\n\t\t\t\t\t  color: val == property.no_shop ? '#014116' : '#cccccc',\r\n\t\t\t\t\t  fontWeight: val == property.no_shop ? 'BOLD' : 'NORMAL',\r\n\t\t\t\t\t},\r\n\t\t\t\t  })\r\n\t\t\t\t\"\r\n\t\t\t\t@drag-end=\"(value) => validate()\"\r\n\t\t\t  ></vueSlider>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t</div>\r\n\t\t<div v-if=\"check_section_enabled(section_features)\" class=\"row mt-4\">\r\n\t\t  <div class=\"features-content\">\r\n\t\t\t<h3>\r\n\t\t\t  {{ helper.t(\"Features\") }}\r\n\t\t\t</h3>\r\n\t\t\t<div class=\"row\">\r\n\t\t\t  <div\r\n\t\t\t\tv-for=\"feature in section_features\"\r\n\t\t\t\tv-if=\"check_enabled(feature) && !rega_features.includes(feature)\"\r\n\t\t\t\tclass=\"col-lg-3 col-md-4\"\r\n\t\t\t  >\r\n\t\t\t\t<ul>\r\n\t\t\t\t  <li\r\n\t\t\t\t\t@click=\"\r\n\t\t\t\t\t  property[feature] = !property[feature];\r\n\t\t\t\t\t  set_for_type(feature);\r\n\t\t\t\t\t\"\r\n\t\t\t\t  >\r\n\t\t\t\t\t<i\r\n\t\t\t\t\t  v-if=\"property[feature]\"\r\n\t\t\t\t\t  class=\"ri-checkbox-circle-fill\"\r\n\t\t\t\t\t></i>\r\n\t\t\t\t\t<i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n\t\t\t\t\t{{ helper.t(feature) }}\r\n\t\t\t\t  </li>\r\n\t\t\t\t</ul>\r\n\t\t\t  </div>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t</div>\r\n\t\t<div class=\"row\">\r\n\t\t  <div\r\n\t\t\tv-if=\"check_enabled('price_sqr_meter')\"\r\n\t\t\tclass=\"col-lg-4 col-sm-6\"\r\n\t\t  >\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label v-if=\"property.ad_type == 'Rent'\">\r\n\t\t\t\t{{ property.property_type != 'Land'?helper.t(\"Yearly Rent\"):helper.t(\"Yearly rent per Square Meter\") }}\r\n\t\t\t  </label>\r\n\t\t\t  <label v-else>\r\n\t\t\t\t{{ property.property_type != 'Land'?helper.t(\"Total Price\"):helper.t(\"Price per Square Meter\") }}\r\n\t\t\t  </label>\r\n\t\t\t  <input\r\n\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\tv-model=\"property.price_sqr_meter\"\r\n\t\t\t\ttype=\"number\"\r\n\t\t\t\t:class=\"check_error('price_sqr_meter')\"\r\n\t\t\t\t:min=\"property.rega_data['propertyPrice']\"\r\n\t\t\t\t@change=\"\r\n\t\t\t\t  calculate_total_price();\r\n\t\t\t\t  validate();\r\n\t\t\t\t\"\r\n\t\t\t  />\r\n\t\t\t  <small>{{ helper.t(\"Cannot go below {0}\",[ property.rega_data[\"propertyPrice\"] ]) }}</small>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div\r\n\t\t\tv-if=\"property.property_type == 'Land'\"\r\n\t\t\tclass=\"col-lg-4 col-sm-6\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label v-if=\"property.ad_type == 'Rent'\">{{\r\n\t\t\t\thelper.t(\"Yearly Rent\")\r\n\t\t\t  }}</label>\r\n\t\t\t  <label v-else>{{ helper.t(\"Total Price\") }}</label>\r\n\t\t\t  <input\r\n\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\tv-model=\"property.total_price\"\r\n\t\t\t\ttype=\"number\"\r\n\t\t\t\t:class=\"check_error('total_price')\"\r\n\t\t\t\tdisabled\r\n\t\t\t  />\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div v-if=\"check_enabled('description')\" class=\"col-lg-12\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label>{{ helper.t(\"Description\") }}</label>\r\n\t\t\t  <textarea\r\n\t\t\t\tv-model=\"property.description\"\r\n\t\t\t\tname=\"massage\"\r\n\t\t\t\t:class=\"check_error('description')\"\r\n\t\t\t\t@change=\"validate\"\r\n\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t\tcols=\"30\"\r\n\t\t\t\trows=\"6\"\r\n\t\t\t  ></textarea>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div class=\"col-lg-12\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label> {{ helper.t(\"Property Images\") }} </label>\r\n\t\t\t  <div\r\n\t\t\t\tclass=\"row images-container\"\r\n\t\t\t\t:class=\"check_error('main_image_index')\"\r\n\t\t\t  >\r\n\t\t\t\t<div\r\n\t\t\t\t  v-for=\"(image, image_index) in property.images\"\r\n\t\t\t\t  class=\"col-sm-6 col-md-3 image-input-container\"\r\n\t\t\t\t>\r\n\t\t\t\t  <div\r\n\t\t\t\t\t@click=\"property.main_image_index = image_index\"\r\n\t\t\t\t\tclass=\"imagePreviewWrapper\"\r\n\t\t\t\t\t:style=\"{\r\n\t\t\t\t\t  'background-image': `url(${\r\n\t\t\t\t\t\timage.link ? image.link : image.data\r\n\t\t\t\t\t  })`,\r\n\t\t\t\t\t}\"\r\n\t\t\t\t  ></div>\r\n\t\t\t\t  <i\r\n\t\t\t\t\t@click=\"remove_image(image)\"\r\n\t\t\t\t\tclass=\"fa-solid fa-trash fa-2x delete text-danger\"\r\n\t\t\t\t  ></i>\r\n\t\t\t\t  <i\r\n\t\t\t\t\tv-if=\"image_index == property.main_image_index\"\r\n\t\t\t\t\tclass=\"fa-solid fa-square-check fa-2x main text-primary\"\r\n\t\t\t\t  ></i>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-lg-3 image-input-container\">\r\n\t\t\t\t  <label\r\n\t\t\t\t\t:for=\"is_child ? 'file_child' : 'file_parent'\"\r\n\t\t\t\t\tclass=\"imageEmptyWrapper\"\r\n\t\t\t\t  ></label>\r\n\t\t\t\t  <input\r\n\t\t\t\t\t:id=\"is_child ? 'file_child' : 'file_parent'\"\r\n\t\t\t\t\tclass=\"input-file\"\r\n\t\t\t\t\t:ref=\"is_child ? 'file_input_child' : 'file_input_parent'\"\r\n\t\t\t\t\ttype=\"file\"\r\n\t\t\t\t\t@input=\"pickFile\"\r\n\t\t\t\t\taccept=\"image/png, image/gif, image/jpeg\"\r\n\t\t\t\t\tmultiple\r\n\t\t\t\t  />\r\n\t\t\t\t</div>\r\n\t\t\t  </div>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div class=\"col-lg-6 col-sm-6\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label> {{ helper.t(\"Video Link (Youtube)\") }} </label>\r\n\t\t\t  <input\r\n\t\t\t\tv-model=\"property.video\"\r\n\t\t\t\ttype=\"text\"\r\n\t\t\t\t:class=\"check_error('video')\"\r\n\t\t\t\t@change=\"validate\"\r\n\t\t\t\tclass=\"form-control border-radius\"\r\n\t\t\t  />\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div v-if=\"check_enabled('location')\" class=\"col-lg-12\">\r\n\t\t\t<div class=\"alert alert-info\" role=\"alert\"><i class=\"fa-solid fa-triangle-exclamation fa-xl\"></i> <b>{{ helper.t(\"Please match the location on the map with the location according to the deed\") }}</b>\r\n\t\t\t  <template v-if=\"property.rega_data.locationDescriptionOnMOJDeed && property.rega_data.locationDescriptionOnMOJDeed != ''\">: {{ property.rega_data.locationDescriptionOnMOJDeed }}</template>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"form-group p-2 input position-relative\" :class=\"check_error('location')\">\r\n\t\t\t  <div id=\"map\"></div>\r\n\t\t\t  <div class=\"legend top-0 start-0\">\r\n\t\t\t\t<h4>{{ helper.t(\"Location Info.\") }}</h4>\r\n\t\t\t\t<table class=\"table table-striped\">\r\n\t\t\t\t  <tbody>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t  <td>{{ helper.t(\"Region\") }}</td><td class=\"count\">{{ property.rega_data.location.region }}</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t  <td>{{ helper.t(\"City\") }}</td><td class=\"count\">{{ property.rega_data.location.city }}</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t  <td>{{ helper.t(\"District\") }}</td><td class=\"count\">{{ property.rega_data.location.district }}</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t  <td>{{ helper.t(\"Street\") }}</td><td class=\"count\">{{ property.rega_data.location.street }}</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t  <td>{{ helper.t(\"Postal Code\") }}</td><td class=\"count\">{{ property.rega_data.location.postalCode }}</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t  <td>{{ helper.t(\"Building Num\") }}</td><td class=\"count\">{{ property.rega_data.location.buildingNumber }}</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t  <td>{{ helper.t(\"Additional Num\") }}</td><td class=\"count\">{{ property.rega_data.location.additionalNumber }}</td>\r\n\t\t\t\t\t</tr>                  \r\n\t\t\t\t  </tbody>\r\n\t\t\t\t</table>\r\n\t\t\t  </div>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div v-if=\"check_enabled('allow_call')\" class=\"col-lg-6 col-md-6\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label>{{\r\n\t\t\t\thelper.t(\"Allow Users to see mobile number?\")\r\n\t\t\t  }}</label\r\n\t\t\t  ><br />\r\n\t\t\t  <div class=\"btn-group me-2\" role=\"group\">\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"property.allow_call = false;\"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.allow_call == false\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"No\") }}\r\n\t\t\t\t</button>\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"property.allow_call = true\"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.allow_call == true\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"Yes\") }}\r\n\t\t\t\t</button>\r\n\t\t\t  </div>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div v-if=\"check_enabled('allow_whatsapp')\" class=\"col-lg-6 col-md-6\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label>{{\r\n\t\t\t\thelper.t(\"Allow Users to Contact on Whatsapp?\")\r\n\t\t\t  }}</label\r\n\t\t\t  ><br />\r\n\t\t\t  <div class=\"btn-group me-2\" role=\"group\">\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"property.allow_whatsapp = false\"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.allow_whatsapp == false\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"No\") }}\r\n\t\t\t\t</button>\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"property.allow_whatsapp = true;\"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.allow_whatsapp == true\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"Yes\") }}\r\n\t\t\t\t</button>\r\n\t\t\t  </div>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t  <div v-if=\"check_enabled('publish')\" class=\"col-lg-6 col-md-6\">\r\n\t\t\t<div class=\"form-group\">\r\n\t\t\t  <label>{{ helper.t(\"Publish on Maalek After Saving?\") }}</label\r\n\t\t\t  ><br />\r\n\t\t\t  <div class=\"btn-group me-2\" role=\"group\">\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"property.publish = false\"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.publish == false\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"No\") }}\r\n\t\t\t\t</button>\r\n\t\t\t\t<button\r\n\t\t\t\t  type=\"button\"\r\n\t\t\t\t  class=\"btn\"\r\n\t\t\t\t  @click.prevent=\"property.publish = true\"\r\n\t\t\t\t  :class=\"\r\n\t\t\t\t\tproperty.publish == true\r\n\t\t\t\t\t  ? 'btn-primary'\r\n\t\t\t\t\t  : 'btn-outline-secondary'\r\n\t\t\t\t  \"\r\n\t\t\t\t>\r\n\t\t\t\t  {{ helper.t(\"Yes\") }}\r\n\t\t\t\t</button>\r\n\t\t\t  </div>\r\n\t\t\t</div>\r\n\t\t  </div>\r\n\t\t</div>\r\n\t  </form>\r\n\t</div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nimport * as global from \"../../js/global\";\r\nimport * as helper from \"../../js/helper\";\r\nimport full_loading from \"../components/full-loading.vue\";\r\nimport vueSlider from \"vue-slider-component\";\r\nexport default {\r\n  components: {\r\n\tfull_loading: full_loading,\r\n\tvueSlider: vueSlider,\r\n  },\r\n  name: \"add_property_widget\",\r\n  props: {\r\n\tproperty: {\r\n\t  type: Object,\r\n\t},\r\n\tis_child: {\r\n\t  type: Boolean,\r\n\t  default: false,\r\n\t},\r\n\tis_edit: {\r\n\t  type: Boolean,\r\n\t  default: false,\r\n\t},\r\n\tpreviewImage: null,\r\n  },\r\n  data() {\r\n\treturn {\r\n\t  is_ready:false,\r\n\t  global,\r\n\t  helper,\r\n\t  frappe,\r\n\t  section_features: global.property_constants.section_features,\r\n\t  rega_features: global.property_constants.rega_features,\r\n\t  section_details: global.property_constants.section_details,\r\n\t  property: null,\r\n\t  map: null,\r\n\t  map_marker: null,\r\n\t  mapsLayerGroup: null,\r\n\t  marker_popup: null,\r\n\t  target_latlng: null,\r\n\t  initial_lat_lng: null,\r\n\t  markerLayerGroup: null,\r\n\t  marks_0_10: (val) => ({\r\n\t\tlabel: val === 10 ? \"10+\" : `${val}`,\r\n\t\t// labelStyle: {\r\n\t\t//     color: val==property.no_bed?'#014116':'#cccccc',\r\n\t\t//     fontWeight: val==property.no_bed?'BOLD':'NORMAL',\r\n\t\t// }\r\n\t  }),\r\n\t};\r\n  },\r\n  mounted() {\r\n\t// this.property.price_sqr_meter = this.property.price_sqr_meter.toFixed(0);\r\n\tglobal.emitter.on(\"update-property-form\", (args) => {\r\n\t  this.$forceUpdate();\r\n\t});\r\n\t// this.property = this.property_obj;\r\n\tthis.setup_things([this.property.lat,this.property.lng]);\r\n\t// this.property.total_price = this.property.total_price.toFixed(0);\r\n  },\r\n  methods: {\r\n\tsetup_things: async function (initial_lat_lng = [24.69999996, 46.73333003]) {\r\n\t  var initial_lat = initial_lat_lng[0]; \r\n\t  var initial_lng = initial_lat_lng[1];\r\n\t  if (!this.is_child) {\r\n\t\tlet corner1 = L.latLng(31.896210012370656, 33.96066018865814);\r\n\t\tlet corner2 = L.latLng(17.613607036429755, 55.8301100044458);\r\n\t\tvar google_street_layer = L.tileLayer(\r\n\t\t  \"https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}\",\r\n\t\t  {\r\n\t\t\tmaxZoom: 18,\r\n\t\t\tminZoom: 6,\r\n\t\t\tsubdomains: [\"mt0\", \"mt1\", \"mt2\", \"mt3\"],\r\n\t\t\tattribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n\t\t  }\r\n\t\t);\r\n\t\tvar google_satellite_layer = L.tileLayer(\r\n\t\t  \"https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}\",\r\n\t\t  {\r\n\t\t\tmaxZoom: 18,\r\n\t\t\tminZoom: 6,\r\n\t\t\tsubdomains: [\"mt0\", \"mt1\", \"mt2\", \"mt3\"],\r\n\t\t\tattribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n\t\t  }\r\n\t\t);\r\n\t\tvar open_street = L.tileLayer(\r\n\t\t  \"https://tile.openstreetmap.org/{z}/{x}/{y}.png\",\r\n\t\t  {\r\n\t\t\tmaxZoom: 18,\r\n\t\t\tminZoom: 6,\r\n\t\t\tattribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n\t\t  }\r\n\t\t);\r\n\t\tthis.mapsLayerGroup = new L.LayerGroup();\r\n\t\tthis.markerLayerGroup = new L.LayerGroup();\r\n\t\tthis.map = L.map(\"map\", {\r\n\t\t  center: [initial_lat, initial_lng],\r\n\t\t  zoom: 17,\r\n\t\t  maxZoom: 18,\r\n\t\t  minZoom: 12,\r\n\t\t  dragging: false,\r\n\t\t  maxBounds: L.latLngBounds(corner1, corner2),\r\n\t\t  layers: [\r\n\t\t\tthis.mapsLayerGroup,\r\n\t\t\tthis.markerLayerGroup,\r\n\t\t  ],\r\n\t\t}); //.setView([26.354351281510784, 43.95774780060444], 11);\r\n\t\tthis.map.scrollWheelZoom.disable();\r\n\t\tthis.mapsLayerGroup.addLayer(open_street);\r\n\r\n\t\tthis.map_marker = L.marker([initial_lat, initial_lng]);\r\n\t\tthis.marker_popup = L.popup();\r\n\t\tthis.markerLayerGroup.addLayer(this.map_marker);\r\n\t\tthis.map_marker.bindPopup(this.marker_popup);\r\n\t\tvar baseLayers = frappe.lang_dir=='ltr'?{\r\n\t\t  \"Map 1\": open_street,\r\n\t\t  \"Map 2\": google_street_layer,\r\n\t\t  \"Satellite\": google_satellite_layer,\r\n\t\t}:{\r\n\t\t  \"الخريطة 1\": open_street,\r\n\t\t  \"الخريطة 2\": google_street_layer,\r\n\t\t  \"القمر الصناعي\": google_satellite_layer,\r\n\t\t};\r\n\t\tvar layerControl = L.control.layers(baseLayers).addTo(this.map);\r\n\t\t\r\n\t\t//.........\r\n\t\tvar customControl =  L.Control.extend({\r\n\t\t  options: {\r\n\t\t\tposition: 'topleft'\r\n\t\t  },\r\n\t\t});\r\n\t\tthis.map.addControl(new customControl());\r\n\t\t//.........\r\n\r\n\t\tif (this.is_edit) {\r\n\t\t  latlng = L.latLng(initial_lat, initial_lng)\r\n\t\t  this.map_marker.setLatLng(latlng);\r\n\t\t  this.marker_popup.setLatLng(this.map_marker.getLatLng());\r\n\t\t  this.map.panTo(latlng);\r\n\t\t}\r\n\t  }\r\n\t  this.is_ready = true;\r\n\t  if(!this.is_edit){\r\n\t\tnavigator.geolocation.getCurrentPosition(this.getCurrentPositionSuccess,this.getCurrentPositionError);\r\n\t  }\r\n\t},\r\n\tcheck_enabled: function (field) {\r\n\t  // return true;\r\n\t  if (this.property.property_type == \"\") return false;\r\n\t  working_fields = this.enabled_fields;\r\n\t  return working_fields.includes(field);\r\n\t},\r\n\tcheck_section_enabled: function (array) {\r\n\t  return this.enabled_fields.some((feature) => array.includes(feature));\r\n\t},\r\n\tremove_image(image) {\r\n\t  var image_index = this.property.images.indexOf(image);\r\n\t  if (image_index >= 0) this.property.images.splice(image_index, 1);\r\n\t  if (this.property.images.length <= this.property.main_image_index)\r\n\t\tthis.property.main_image_index = this.property.images.length - 1;\r\n\t  if (this.property.main_image_index < 0)\r\n\t\tthis.property.main_image_index = 0;\r\n\t  else this.validate();\r\n\t},\r\n\tpickFile() {\r\n\t  let input = null;\r\n\t  let files = null;\r\n\t  if (!this.is_child) {\r\n\t\tinput = this.$refs.file_input_parent;\r\n\t\tfiles = input.files;\r\n\t  } else {\r\n\t\tinput = this.$refs.file_input_child;\r\n\t\tfiles = input.files;\r\n\t  }\r\n\t  if (files && files[0]) {\r\n\t\tfor (let index = 0; index < files.length; index++) {\r\n\t\t  const single_file = files[index];\r\n\t\t  let reader = new FileReader();\r\n\t\t  reader.onload = (event) => {\r\n\t\t\tvar image = new Image();\r\n\t\t\timage.onload = ()=>{\r\n\t\t\t  var canvas=document.createElement(\"canvas\");\r\n\t\t\t  var context=canvas.getContext(\"2d\");\r\n\t\t\t  const size = 1024; // set your width\r\n\t\t\t  var scaleFactor = size / image.width;\r\n\t\t\t  canvas.width = image.width;\r\n\t\t\t  canvas.height = image.height;\r\n\t\t\t  if(image.width > image.height && image.width > size){\r\n\t\t\t\tscaleFactor = size / image.width;\r\n\t\t\t\tcanvas.width = size;\r\n\t\t\t\tcanvas.height = image.height * scaleFactor;\r\n\t\t\t  }else if(image.width < image.height && image.height > size){\r\n\t\t\t\tscaleFactor = size / image.height;\r\n\t\t\t\tcanvas.width = image.width * scaleFactor;\r\n\t\t\t\tcanvas.height = size;\r\n\t\t\t  }\r\n\t\t\t  context.drawImage(image, 0, 0, canvas.width, canvas.height);\r\n\t\t\t  this.property.images.push(\r\n\t\t\t\tnew global.image_file({\r\n\t\t\t\t  data: canvas.toDataURL(\"image/jpeg\"),\r\n\t\t\t\t  file: single_file.name,\r\n\t\t\t\t})\r\n\t\t\t  );\r\n\t\t\t}\r\n\t\t\timage.src=event.target.result;\r\n\t\t\tthis.validate();\r\n\t\t  };\r\n\t\t  reader.readAsDataURL(single_file);\r\n\t\t}\r\n\t\tthis.$forceUpdate();\r\n\t  }\r\n\t},\r\n\tcheck_error(field) {\r\n\t  return this.property.errors.includes(field) ? \"error\" : \"\";\r\n\t},\r\n\tvalidate() {\r\n\t  if (this.property.errors.length > 0) this.property.validate();\r\n\t},\r\n\tcalculate_total_price() {\r\n\t  this.property.price_sqr_meter = Number(Number((this.property.price_sqr_meter)).toFixed(0));\r\n\r\n\t  if(this.property.price_sqr_meter < this.property.rega_data[\"propertyPrice\"]){\r\n\t\tconsole.log(\"in\")\r\n\t\tthis.property.price_sqr_meter = this.property.rega_data[\"propertyPrice\"];\r\n\t  }\r\n\r\n\t  this.property.total_price = (Number(this.property.size) * this.property.price_sqr_meter).toFixed(0);\r\n\t},\r\n\tset_for_type(feature) {\r\n\t  if (feature == \"is_family\") {\r\n\t\tif (!this.property.is_family) {\r\n\t\t  this.property.for_type = \"Single\";\r\n\t\t} else if (this.property.for_type == \"Single\") {\r\n\t\t  this.property.for_type = \"Both\";\r\n\t\t}\r\n\t  }\r\n\t  if (feature == \"is_inside_villa\" && this.property.is_inside_villa) {\r\n\t\tthis.property.is_inside_building = 0\r\n\t  }else if (feature == \"is_inside_building\" && this.property.is_inside_building) {\r\n\t\tthis.property.is_inside_villa = 0\r\n\t  }\r\n\t},\r\n\tadd_view_side(side){\r\n\t  normal_sides = [\"N\",\"S\",\"E\",\"W\"]\r\n\t  diagonal_sides = [\"NW\",\"NE\",\"SW\",\"SE\"]\r\n\t  if(this.property.view_sides.includes(side)){\r\n\t\tif(this.property.view_sides[0] == side)\r\n\t\t  this.property.view_sides.splice(this.property.view_sides.indexOf(side), 1);\r\n\t\telse\r\n\t\t  this.property.view_sides.sort(function(x,y){ return x == side ? -1 : y == side ? 1 : 0; });\r\n\t\treturn;\r\n\t  }\r\n\t  if(normal_sides.includes(side)){\r\n\t\tif(this.property.view_sides.some(value => diagonal_sides.includes(value))){\r\n\t\t  this.property.view_sides = [];\r\n\t\t}\r\n\t  }else if(diagonal_sides.includes(side)){\r\n\t\tif(this.property.view_sides.some(value => normal_sides.includes(value))){\r\n\t\t  this.property.view_sides = [];\r\n\t\t}\r\n\t  }\r\n\t  this.property.view_sides.push(side);\r\n\t},\r\n\tactive_view_side(side){\r\n\t  return this.property.view_sides.includes(side)?\"active\":\"\"\r\n\t},\r\n\tmain_view_side(side){\r\n\t  return this.property.view_sides[0] == side\r\n\t},\r\n\tget_view_sides(){\r\n\t  normal_sides = [\"N\",\"S\",\"E\",\"W\"]\r\n\t  diagonal_sides = [\"NW\",\"NE\",\"SW\",\"SE\"]\r\n\t  all_sides = [\"N\",\"S\",\"E\",\"W\",\"NW\",\"NE\",\"SW\",\"SE\"]\r\n\t  var sides = \"\";\r\n\t  for (let i = 0; i < all_sides.length; i++){\r\n\t\tif(this.property.view_sides.includes(all_sides[i])){\r\n\t\t  if(this.property.view_sides[0] == all_sides[i])\r\n\t\t\tsides += all_sides[i].toLowerCase() + \"m \";\r\n\t\t  else\r\n\t\t\tsides += all_sides[i].toLowerCase() + \" \";\r\n\t\t}\r\n\t  }\r\n\t  if(this.property.view_sides.some(value => diagonal_sides.includes(value))){\r\n\t\tsides += \"rotate \";\r\n\t  }\r\n\t  return sides;\r\n\t}\r\n  },\r\n  computed: {\r\n\tsave_btn_text() {\r\n\t  if (this.property.publish) return \"Save This Property & Publish Now\";\r\n\t  return \"Save Property\";\r\n\t},\r\n\tenabled_fields() {\r\n\t  var tmp_fields =\r\n\t\tglobal.property_constants.property_types[this.property.property_type];\r\n\t  var fields = JSON.parse(JSON.stringify(Array.from(tmp_fields)));\r\n\t  global.property_constants.remove_field[this.property.ad_type].forEach(\r\n\t\t(field) => {\r\n\t\t  const index = fields.indexOf(field);\r\n\t\t  if (index > -1) {\r\n\t\t\t// only splice array when item is found\r\n\t\t\tfields.splice(index, 1); // 2nd parameter means remove one item only\r\n\t\t  }\r\n\t\t}\r\n\t  );\r\n\t  global.property_constants.rega_features.forEach((field) => {\r\n\t\tconst index = fields.indexOf(field);\r\n\t\tif (index > -1) {\r\n\t\t  fields.splice(index, 1);\r\n\t\t}\r\n\t  });\r\n\t  return fields;\r\n\t},\r\n  },\r\n};\r\n</script>\r\n\r\n<style>\r\n.image-input-container {\r\n  display: block;\r\n  position: relative;\r\n}\r\n.image-input-container .delete {\r\n  position: absolute;\r\n  top: 5%;\r\n  right: 10%;\r\n  text-shadow: 1px 1px 2px #000;\r\n}\r\n.image-input-container .main {\r\n  position: absolute;\r\n  top: 5%;\r\n  left: 10%;\r\n  text-shadow: 1px 1px 2px #000;\r\n}\r\n.image-input-container .input-file {\r\n  height: 0.1px;\r\n  width: 0.1px;\r\n  display: none;\r\n}\r\n.imagePreviewWrapper {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  display: block;\r\n  cursor: pointer;\r\n  margin: 0 auto 30px;\r\n  background-color: aliceblue;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n.imageEmptyWrapper {\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  display: block;\r\n  cursor: pointer;\r\n  margin: 0 auto 30px;\r\n  background-color: aliceblue;\r\n  background-image: url(\"/assets/maalek/images/circle-plus-solid.svg\");\r\n  background-repeat: no-repeat;\r\n  background-size: 20%;\r\n  background-position: center;\r\n}\r\n.images-container {\r\n  padding: 5px;\r\n}\r\n.images-container.error {\r\n  border: SOLID 1px red;\r\n  background-color: rgba(255, 0, 0, 0.1215686275) !important;\r\n}\r\n#map {\r\n  height: 480px;\r\n}\r\n\r\n.view_sides{\r\n  direction:ltr\r\n}\r\n\r\n.view_sides .btn{\r\n  width:150px;\r\n}\r\n\r\n.view-sides-preview .preview{\r\n  height: 135px;\r\n  width: 135px;\r\n  margin: auto;\r\n  border: SOLID 10px LIGHTGRAY;\r\n}\r\n\r\n.view-sides-preview .rotate{\r\n  transform: rotateY(0deg) rotate(45deg);\r\n}\r\n\r\n.view-sides-preview .n, .view-sides-preview .ne{\r\n  border-top-color: #014116;\r\n}\r\n\r\n.view-sides-preview .s,.view-sides-preview .sw{\r\n  border-bottom-color: #014116;\r\n}\r\n\r\n.view-sides-preview .e,.view-sides-preview .se{\r\n  border-right-color: #014116;\r\n}\r\n\r\n.view-sides-preview .w, .view-sides-preview .nw{\r\n  border-left-color: #014116;\r\n}\r\n\r\n.view-sides-preview .nm, .view-sides-preview .nem{\r\n  border-top-color: orange;\r\n}\r\n\r\n.view-sides-preview .sm,.view-sides-preview .swm{\r\n  border-bottom-color: orange;\r\n}\r\n\r\n.view-sides-preview .em,.view-sides-preview .sem{\r\n  border-right-color: orange;\r\n}\r\n\r\n.view-sides-preview .wm, .view-sides-preview .nwm{\r\n  border-left-color: orange;\r\n}\r\n\r\n.leaflet-container{\r\n  font-family: \"changa\", 'Source Sans Pro', sans-serif !important;\r\n  font-size: small !important;\r\n}\r\n\r\n.legend {\r\n  margin: 100px 20px;\r\n  padding: 6px 4px;\r\n  font-size: 14px;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  line-height: 24px;\r\n  color: #555;\r\n  z-index: 500;\r\n  position: absolute;\r\n}\r\n.legend tr {\r\n  cursor: pointer;\r\n}\r\n.legend:hover {\r\n  background: white;\r\n}\r\n.legend h4 {\r\n  text-align: center;\r\n  font-size: 16px;\r\n  margin: 2px 12px 8px;\r\n  color: #777;\r\n}\r\n\r\n.legend img {\r\n  width: 20px;\r\n  height: 24px;\r\n}\r\n\r\n.legend i {\r\n  width: 18px;\r\n  height: 18px;\r\n  float: left;\r\n  margin: 0 8px 0 0;\r\n  opacity: 0.7;\r\n}\r\n\r\n.legend i.icon {\r\n  background-size: 18px;\r\n  background-color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/property-form.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__